<template>
    <div v-if="shops && shops.length > 0">
        <p class="vehicle-page-flow__headline">{{ dictionary.flowNewsletterSignupHeadline }}</p>
        <div v-if="shops.length > 1">
            <p>{{ dictionary.flowNewsletterSignupSubheadlineMultiple }}</p>
            <div class="formgrid grid">
                <div class="field col-12 sm:col-7">
                    <Dropdown appendTo="self" placeholder="Vælg afdeling" v-model="selectedShop" :options="shops"
                        optionLabel="departmentName" />
                </div>
                <div class="field col-12 sm:col-5">
                    <Button v-if="selectedShop != null" @click="() => { selectedShop = null; }" label="Fjern samtykke"
                        icon="pi pi-times" icon-pos="right" severity="danger" class="p-button-sm"></Button>
                </div>
            </div>
        </div>
        <div v-else>
            <p
                v-html="dictionary.flowNewsletterSignupSubheadlineSingle.replace('{departmentName}', shops[0].departmentName)">
            </p>
            <div class="formgrid grid">
                <div class="field-checkbox col-12">
                    <Checkbox name="consent" :binary="true" inputId="consent" v-model="consents" />
                    <label for="consent"
                        v-html="dictionary.flowNewsletterSignupCheckboxLabel.replace('{departmentName}', shops[0].departmentName)"></label>
                </div>
            </div>
        </div>
        <DynamicDialog></DynamicDialog>

    </div>
</template>
<script>

import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import DynamicDialog from 'primevue/dynamicdialog';
import ConsentDialogContent from './consentDialogContent';
import { nextTick } from 'vue'

export default {
    name: "flowNewsletterSignup",
    props: ['dealerId', 'selectedShopId','vehicleBrandAlias'],
    data() {
        return {
            dictionary: [],
            selectedShop: null,
            shops: null,
            consents: false,
            isInitiating: true,
        }
    },
    components: {
        Dropdown,
        Checkbox,
        Button,
        DynamicDialog,
        ConsentDialogContent
    },
    created() {
        const vm = this;

        fetch('/umbraco/api/resourcesApi/GetFlowNewsletterSignupDictionary').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });


        fetch(`/umbraco/api/shopApi/getShopsById?shopIds=${this.dealerId}`).then((response) => response.json())
            .then((data) => {
                if(vm.vehicleBrandAlias == 'volkswagenerhverv'){
                    vm.shops = data.map(x => x.departments.find(x => x.typeId == 5 || x.typeId == 16)).filter(x => x !== undefined);
                }else {
                    vm.shops = data.map(x => x.departments.find(x => x.typeId == 2)).filter(x => x !== undefined);
                }

                if (vm.selectedShopId) {
                    vm.selectedShop = vm.shops.find(x => x.id == vm.selectedShopId);
                    vm.consents = true;
                }
                nextTick(() => {
                    vm.isInitiating = false;
                });
            })
            .catch((error) => {
                console.log(error);
            });

    },
    watch: {
        consents(newVal, oldVal) {
            if (!this.isInitiating) {
                if (oldVal == false && newVal == true) {
                    this.showConsentText(this.shops[0]);
                } else if (newVal == false) {
                    this.selectedShop = null;
                    this.$emit('consentChanged', null);
                }
            }
        },
        selectedShop(newVal, oldVal) {
            if (!this.isInitiating) {

                if (newVal != null) {
                    this.showConsentText(newVal);
                } else {
                    this.$emit('consentChanged', null);
                }
            }
        }
    },
    methods: {
        showConsentText(shop) {
            const vm = this;

            fetch('/umbraco/api/consentApi/GetConsentText?brand=' + shop.brand.fullBrandAliasCleaned).then(response => response.json()).then(data => {

                vm.$dialog.open(ConsentDialogContent, {
                    props: {
                        header: vm.dictionary.consentDialogHeader.replace('{brand}', shop.brand.displayName),
                        modal: true,
                        blockScroll: true,
                        draggable: false,
                    },
                    data: {
                        consentText: data.text,
                        consentTextId: vm.consentTextId,
                        labelText: vm.dictionary.consentDialogLabelText,
                        buttonText: vm.dictionary.consentDialogButtonText
                    },
                    onClose: (e) => {
                        if (e.data?.accepted) {
                            vm.consentedShop = shop;
                            vm.$emit('consentChanged', { shopId: shop.parentShopId, brand: shop.brand.fullBrandAliasCleaned, consentTextId: data.id, departmentName: shop.departmentName });
                        } else {
                            vm.selectedShop = null;
                            vm.$emit('consentChanged', null);

                        }


                    }
                });



            });
        },
    }
};
</script>
